import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT_HIDDEN = ["pack-iniciacion", "practica-introspeccion"];

export const useResourceStatus = () => {
  const [status, setStatus] = useState(null);
  useEffect(() => { api.get("/resources-status").then((r) => setStatus(r.data)).catch(() => {}); }, []);
  return status;
};

export const isVisible = (status, slug) => (status ? status[slug]?.visible !== false : !DEFAULT_HIDDEN.includes(slug));
